import type { CopilotConfigurationTemplate } from '@factoryfixinc/ats-interfaces';

type OwnedTemplate = Pick<CopilotConfigurationTemplate, 'ownerId'>;

/** A team-owned recruiter has no owner and is maintained by the employer's admins. */
export function isTeamOwnedTemplate(template: OwnedTemplate): boolean {
  return template.ownerId === null;
}

/** True only for a person-owned recruiter whose owner is `userId`; never true for team-owned. */
export function isTemplateOwnedBy(template: OwnedTemplate, userId: number | undefined): boolean {
  return !isTeamOwnedTemplate(template) && userId !== undefined && template.ownerId === userId;
}
